<template>
    <div :style="{backgroundColor: color}" class="white--text primary darken-1 discount-label">
        <span class="discount-number">-{{discount}}%</span>
    </div>
</template>

<script>
    export default{
        props: ['discount', 'color']
    }
</script>

<style scoped>
    .discount-label{
        position: absolute;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        top: 5px;
        right: -2px;
        height: 50px;
        width: 80px;
        opacity: .95;
        border-radius: 5px 2px 2px 5px;
        box-shadow: -3px 5px 10px rgba(0, 0, 0, 0.42);
    }

    .discount-number{
        font-size: 1.65em;
        font-weight: bold;
    }

</style>